import { rules } from './rules';

export const validateLogin = (formData) => {
  const errors = {};

  const emailError = rules.email(formData.email);
  if (emailError) errors.email = emailError;

  const passwordError = rules.password(formData.password);
  if (passwordError) errors.password = passwordError;

  return errors;
};
